export class Margin {
    //#region Fields
    private _left: number = 0;
    private _top: number = 0;
    private _right: number = 0;
    private _bottom: number = 0;
    private _defaultUnit: string = "px";
    //#endregion

    //#region Properties
    public get left(): number {
        return this._left;
    }

    public set left(value: number) {
        this._left = value;
    }

    public get top(): number {
        return this._top;
    }

    public set top(value: number) {
        this._top = value;
    }

    public get right(): number {
        return this._right;
    }

    public set right(value: number) {
        this._right = value;
    }

    public get bottom(): number {
        return this._bottom;
    }

    public set bottom(value: number) {
        this._bottom = value;
    }

    public get isNonZero(): boolean {
        return !!(this.left && this.top && this.bottom && this.right);
    }
    //#endregion

    //constructor(top: number = 0, right: number = 0, bottom: number = 0, left: number = 0) { // HTML
    constructor(left: number = 0, top: number = 0, right: number = 0, bottom: number = 0) {
        this.left = left;
        this.top = top;
        this.bottom = bottom;
        this.right = right;
    }

    //#region Methods
    public static parse(margin: string | null): Margin {
        if (margin == undefined || margin == null)
            return new Margin();

        const m: string[] = margin.split(",");
        if (m.length >= 1 && m.length <= 4) {
            if (m.length == 1) {
                const a = parseFloat(m[0]);
                if (isNaN(a))
                    throw Error("Argument exception. Not valid value of margin");

                return new Margin(a, a, a, a);
            } else if (m.length == 2) {
                const a = parseFloat(m[0]);
                const b = parseFloat(m[1]);
                if (isNaN(a) || isNaN(b))
                    throw Error("Argument exception. Not valid value of margin");

                return new Margin(a, b, a, b);
            } else if (m.length == 4) {
                const a = parseFloat(m[0]);
                const b = parseFloat(m[1]);
                const c = parseFloat(m[2]);
                const d = parseFloat(m[3]);
                if (isNaN(a) || isNaN(b) || isNaN(c) || isNaN(d))
                    throw Error("Argument exception. Not valid value of margin");

                return new Margin(a, b, c, d);
            } else {
                throw Error("Argument exception. Not valid value of margin");
            }
        } else
            throw Error("Argument exception. Not valid value of margin");
    }

    public toString(): string {
        if (this.left == 0 && this.right == 0 && this.top == 0 && this.bottom == 0) {
            return "0";
        } else if (this.left == this.top && this.top == this.bottom && this.left == this.right) {
            return this.top + this._defaultUnit;
        } else if (this.top == this.bottom && this.left == this.right) {
            return this.top + (this.top != 0 ? this._defaultUnit : "") + " " + this.right + (this.right != 0 ? this._defaultUnit : "");
        } else {
            return this.top + (this.top != 0 ? this._defaultUnit : "") + " " + this.right + (this.right != 0 ? this._defaultUnit : "") + " " +
                this.bottom + (this.bottom != 0 ? this._defaultUnit : "") + " " + this.left + (this.left != 0 ? this._defaultUnit : "");
        }
    }

    //#endregion
}
